// extracted by mini-css-extract-plugin
module.exports = {"modalAlert":"styles_modalAlert__3sleX","linkDone":"styles_linkDone__2-iBc"};